import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlaceHouseIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M27.2 30.8C27.2 30.1372 27.7372 29.6 28.4 29.6C29.0627 29.6 29.6 30.1372 29.6 30.8V31.2H27.2V30.8Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M28.4001 27.2L28.8001 28.8V30.8L27.6001 31.2L28.0001 28.8L27.6001 26L28.4001 27.2Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.9641 24.5798C30.8484 22.9019 29.4557 21.6 27.7739 21.6C27.7237 21.6 27.6727 21.6 27.6208 21.6C25.7686 21.6 25.5201 23.9004 25.6181 25.7429C25.6887 27.0695 26.8527 28 28.1812 28C29.8137 28 31.1046 26.617 30.9923 24.9884L30.9641 24.5798Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.984 22.8842C30.4498 22.2739 29.5445 22.1592 28.8757 22.618C28.598 22.8085 28.2546 23.0442 27.8297 23.3357C26.7871 24.051 26.8761 24.8746 27.2538 25.54C27.7692 26.4479 28.9984 26.4146 29.8593 25.824L30.6852 25.2573C31.4753 24.7153 31.615 23.6051 30.984 22.8842Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.1847 24.484C25.7189 23.8738 26.6242 23.7591 27.2929 24.2179C27.5706 24.4084 27.9141 24.6441 28.339 24.9356C29.3816 25.6509 29.2926 26.4745 28.9149 27.1399C28.3995 28.0478 27.1702 28.0144 26.3094 27.4238L25.4835 26.8572C24.6934 26.3151 24.5537 25.205 25.1847 24.484Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.21105 14.981C2.20749 14.8253 2.26464 14.6743 2.37041 14.5599L12.8001 3.28366L23.2298 14.5599C23.3356 14.6743 23.3927 14.8253 23.3891 14.981L23.0271 30.8137C23.0196 31.1397 22.7533 31.4 22.4272 31.4H3.17297C2.84694 31.4 2.58058 31.1397 2.57313 30.8137L2.21105 14.981Z",
			stroke: "currentColor",
			strokeWidth: 1.2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.2001 15.0187C2.2001 14.868 2.2568 14.7229 2.35894 14.6121L12.8001 3.28527L12.3589 2.87861L12.8001 3.28527L23.2413 14.6121C23.3434 14.7229 23.4001 14.868 23.4001 15.0187V30.6H2.2001V15.0187Z",
			stroke: "currentColor",
			strokeWidth: 1.2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.3999 24.8C10.3999 23.4745 11.4744 22.4 12.7999 22.4C14.1254 22.4 15.1999 23.4745 15.1999 24.8V32H10.3999V24.8Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.3999 6.40002H21.5999V13.6L18.3999 10V6.40002Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12.7999,
			cy: 15.2,
			r: 2.4,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0 31.6C0 30.9373 0.537258 30.4 1.2 30.4H30.8C31.4627 30.4 32 30.9373 32 31.6V32H0V31.6Z",
			fill: "currentColor"
		})
	]
});
export default SvgPlaceHouseIcon;
